import * as React from 'react'
import { IntlProvider } from 'react-intl'
import { Props } from './taxesState'
import { TaxesOverview } from './taxesWidgets'

export default (props: Props): JSX.Element => (
  <IntlProvider locale={window.Gites.locale}>
    <TaxesOverview {...props} />
  </IntlProvider>
)
